import React from 'react';
import { Button, withTheme } from '@rneui/themed';
import { FAIcon, chapterLocator, useOnScrub, usePlaybackMetrics, } from '../../..';
export const UnthemedChapterSkipButton = ({ direction, iconStyle, chapters, }) => {
    const { position } = usePlaybackMetrics();
    const onScrub = useOnScrub();
    if (!chapters || chapters.length <= 0) {
        return null;
    }
    const { prev, next, } = chapterLocator(chapters, position);
    let skipTo;
    if (direction === 'forward') {
        skipTo = next;
    }
    else {
        skipTo = prev;
    }
    const isDisabled = skipTo === undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "clear", disabled: isDisabled, onPress: () => {
                if (skipTo !== undefined && chapters[skipTo]) {
                    onScrub(position, chapters[skipTo].location);
                }
            } },
            React.createElement(FAIcon, { name: direction === 'forward' ? 'step-forward' : 'step-backward', style: iconStyle }))));
};
export const ChapterSkipButton = withTheme(UnthemedChapterSkipButton, 'ChapterSkipButton');
//# sourceMappingURL=ChapterSkipButton.js.map